import { create } from "zustand";
import {
    AnonymousCallRejectionStatusEnum,
    CommunicationSettings,
    DoNotDisturbStatusEnum,
    SelectiveCallAcceptanceStatusEnum,
    SelectiveCallRejectionStatusEnum,
} from "@/clients/ntas/basic-selfcare";

interface CommSettingsStoreInterface {
    commSettings: CommunicationSettings;
    setCommSettings: (commSettings: CommunicationSettings) => void;
    deltaForPatch: CommunicationSettings; // This is used to store the changes made to the commSettings, so that we can send only the changes to the server
    setDeltaForPatch: (deltaForPatch: CommunicationSettings) => void;
}

const commSettingsInitialState: CommunicationSettings = {
    // Default values
    anonymousCallRejection: { status: AnonymousCallRejectionStatusEnum.On },
    callBlocking: { blkAll: false, blkInternational: false },
    callBarring: {
        directoryAssistanceBarring: false,
        internationalBarring: false,
    },
    selectiveCallRejection: { status: SelectiveCallRejectionStatusEnum.Off },
    selectiveCallAcceptance: { status: SelectiveCallAcceptanceStatusEnum.Off },
    doNotDisturb: { status: DoNotDisturbStatusEnum.Off },
};

const useCommSettingsStore = create<CommSettingsStoreInterface>((set) => ({
    commSettings: commSettingsInitialState,
    setCommSettings: (commSettings: CommunicationSettings) => set({ commSettings }),
    deltaForPatch: {},
    setDeltaForPatch: (deltaForPatch: CommunicationSettings) => set({ deltaForPatch }),
}));

export default useCommSettingsStore;
